import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MagnifyingGlass } from '@phosphor-icons/react';

export const ShowsGrid = ({ shows, title }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');

  const filtered = shows.filter(s =>
    s.name.toLowerCase().includes(search.toLowerCase()) ||
    s.location.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4 sm:mb-6">
        <h2 className="text-xl sm:text-2xl font-bold text-white" style={{fontFamily: 'Outfit'}}>{title}</h2>
        {shows.length > 2 && (
          <div className="relative w-full sm:w-72">
            <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#525252]" />
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search shows..."
              className="w-full pl-9 pr-4 py-2 bg-[#0A0A0A] border border-[#262626] rounded-lg text-white text-sm focus:outline-none focus:border-[#0096FF] transition-colors placeholder-[#525252]"
              data-testid="dashboard-show-search"
            />
          </div>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {filtered.length === 0 ? (
          <p className="text-[#9E9E9E] col-span-full">{search ? 'No shows match your search' : 'No shows available'}</p>
        ) : (
          filtered.map((show) => (
            <div
              key={show.id}
              data-testid={`show-card-${show.id}`}
              onClick={() => navigate(`/shows/${show.id}`)}
              className="bg-[#161616] border border-[#262626] rounded-lg p-4 sm:p-6 hover:-translate-y-1 hover:border-[#0096FF]/50 transition-all duration-300 cursor-pointer"
            >
              <div className="mb-3 sm:mb-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-base sm:text-xl font-bold text-white line-clamp-1" style={{fontFamily: 'Outfit'}}>{show.name}</h3>
                  <span className={`px-2 py-1 text-[10px] sm:text-xs rounded-full flex-shrink-0 ml-2 ${
                    show.state === 'LIVE' ? 'bg-[#00D4FF]/20 text-[#00D4FF]' :
                    show.state === 'PUBLISHED' ? 'bg-[#34C759]/20 text-[#34C759]' :
                    show.state === 'DRAFT' ? 'bg-[#FACC15]/20 text-[#FACC15]' :
                    'bg-[#0096FF]/20 text-[#0096FF]'
                  }`}>{show.state}</span>
                </div>
                <p className="text-[#9E9E9E] text-xs sm:text-sm line-clamp-2">{show.description}</p>
              </div>
              <div className="space-y-1.5 text-xs sm:text-sm">
                <p className="text-[#9E9E9E]">
                  <span className="text-white">Location:</span> {show.location}
                </p>
                <p className="text-[#9E9E9E]">
                  <span className="text-white">Dates:</span> {new Date(show.start_date).toLocaleDateString()} - {new Date(show.end_date).toLocaleDateString()}
                </p>
                <p className="text-[#9E9E9E]">
                  <span className="text-white">Classes:</span> {show.classes.length}
                </p>
                {show.entry_deadline && (
                  <p className={`text-xs font-semibold ${new Date() > new Date(show.entry_deadline) ? 'text-[#FF3B30]' : 'text-[#FF9500]'}`} data-testid={`show-deadline-${show.id}`}>
                    {new Date() > new Date(show.entry_deadline) ? 'Entries Closed' : `Entries close: ${new Date(show.entry_deadline).toLocaleDateString()} ${new Date(show.entry_deadline).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}`}
                  </p>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
